import Layout from '@/layout'

const reportRouter = {
  path: "/report/list",
  redirect:'/report/list',
  name:'reportIndex',
  hiddeChilden:true,
  hidden:false,
  meta: { title: 'menu.report', iconClass: 'el-icon-files', module:'report', roles:['PROJECT_USER', 'PROJECT_OBSERVER', 'PROJECT_ADMIN']},
  component: Layout,
  children:[
    {
      path: "/report/list",
      name: "reportList",
      hidden:false,
      hidden:true,
      component: () => import( "@/views/report"),
      meta: { title: 'menu.report', iconClass: 'el-icon-files', module:'report', keepAlive: true, roles:['PROJECT_USER', 'PROJECT_OBSERVER', 'PROJECT_ADMIN']}
    },
    {
      path: "/report/add",
      name: "reportAdd",
      hidden:false,
      component: () => import( "@/views/report/add"),
      meta: { title: 'menu.report', iconClass: 'el-icon-files', module:'report', keepAlive: false, roles:['PROJECT_USER', 'PROJECT_ADMIN']}
    },
    {
      path: "/report/show",
      name: "reportShow",
      hidden:false,
      component: () => import( "@/views/report/add"),
      meta: { title: 'menu.report', iconClass: 'el-icon-files', module:'report', keepAlive: false, roles:['PROJECT_USER', 'PROJECT_OBSERVER', 'PROJECT_ADMIN']}
    }
  ]
}

export default reportRouter